import React from 'react';
import EcoTitle from 'eco-design/base/eco-title';
import EcoImg from 'eco-design/base/eco-img';
import EcoVideo from 'eco-design/base/eco-video';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import getLocal from 'eco-design-reliance/getLocal';

interface Props {}

const OnePicture: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.OnePicture');
    const { locale = 'us' } = getLocal();
    const items = [
        {
            title: t('title1'),
            desc: t('desc1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748663983331/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748663983331/1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748671598848/1-h5.jpg',
        },
        {
            icon: <img className="grid-item-icon" src="https://websiteoss.ecoflow.com/upload/image/1745568051826/icon.svg" />,
            title: t('title2'),
            desc: t('desc2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748670705789/2.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748670705789/2.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748671599026/2-h5.png',
        },
        {
            title: t('title3'),
            desc: t('desc3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748663983750/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748663983750/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748671599218/3-h5.jpg',
        },
        {
            title: t('title4'),
            desc: t('desc4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748663983959/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748663983959/4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748671599406/4-h5.jpg',
        },
        {
            title: t('title5'),
            desc: t.rich('desc5', {
                m: (v: string) => `<span class="mini">${v}</span>`,
            }),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748663983547/5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748663983547/5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748671599587/5-h5.jpg',
        },
    ];

    const IS_JP = locale === 'jp';
    const { isH5 } = useDeviceDetect();

    return (
        <div className={`OnePicture GtmModuleData-section ${style.comp}`} data-section-id="OnePicture">
            <div className="container">
                <EcoTitle title={t('title')} />
                <div className="x-core">
                    <EcoVideo
                        className="x-core-bg"
                        pc="https://websiteoss.ecoflow.com/upload/video/1748510008625/x-core.mp4"
                        h5="https://websiteoss.ecoflow.com/upload/video/1748510008471/x-core-h5.mp4"
                        autoPlay
                        loop
                    />
                    <EcoImg className="x-core-img" pc="https://websiteoss.ecoflow.com/upload/image/1748510269580/X-core.png" />
                    <div className="x-core-desc">{IS_JP && isH5 ? t('x-core-desc2') : t('x-core-desc')}</div>
                </div>

                <div className="one-pricture-grid">
                    {items.map((item, index) => (
                        <div className="grid-item" key={index}>
                            <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} />
                            <div className="grid-item-content">
                                {item.icon}
                                <div className="grid-item-info">
                                    <div className="grid-item-title">{item.title}</div>
                                    <div className="grid-item-desc">{item.desc}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
export default OnePicture;
